/* angular:styles/component:css;2cb9f359ec04fe20d13442e8b8d0712eeec779554f416084871e895eb63673a9;/src/src/app/edge/settings/alerting/component/alerting.component.ts */
ion-select {
  max-width: 100% !important;
  margin: auto;
  padding: 0;
  vertical-align: middle;
}
/*# sourceMappingURL=alerting.component.css.map */
